import { FC, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { AutocompleteRenderGetTagProps, Chip } from '@mui/material';

import TimelineSearchBoxOption from '../../../types/timelineSearchBoxOption.type';
import FilterPopover from './FilterPopover';

type TagProps = {
  index: number;
  selectedOption: TimelineSearchBoxOption;
  isFilterPanelOpen: boolean;
  getTagProps: AutocompleteRenderGetTagProps;
  setShouldApplyFilters: (value: boolean) => void;
  getNewSelectedOption: (option: TimelineSearchBoxOption) => void;
  setIsFilterPanelOpen: (value: boolean) => void;
};

const Tag: FC<TagProps> = ({
  index,
  selectedOption,
  isFilterPanelOpen,
  getTagProps,
  setShouldApplyFilters,
  getNewSelectedOption,
  setIsFilterPanelOpen,
}) => {
  const { t } = useTranslation(['notes', 'common']);

  const [anchorEl, setAnchorEl] = useState<HTMLDivElement | null>(null);
  const [activeIndex, setActiveIndex] = useState<number | null>(null);

  const { key, ...tagProps } = getTagProps({ index });

  return (
    <div>
      <Chip
        {...tagProps}
        variant='filled'
        label={t('notes:' + selectedOption.label)}
        onClick={(e) => {
          setAnchorEl(e.currentTarget);
          setIsFilterPanelOpen(true);
          setActiveIndex(index);
        }}
        onDelete={(e) => {
          setShouldApplyFilters(true);
          tagProps.onDelete(e);
        }}
      />
      <FilterPopover
        isFilterPanelOpen={isFilterPanelOpen}
        selectedOption={selectedOption}
        activeIndex={activeIndex}
        anchorEl={anchorEl}
        index={index}
        setIsFilterPanelOpen={setIsFilterPanelOpen}
        onApplyFilters={getNewSelectedOption}
        setShouldApplyFilters={setShouldApplyFilters}
        setActiveIndex={setActiveIndex}
      />
    </div>
  );
};

export default Tag;
